import React from 'react';
import firebase from 'firebase';
import Moment from 'moment';

const { REACT_APP_CLOUD_FUNCTIONS_DOMAIN } = process.env;

class Order extends React.Component {
  state = {
    isLoading: true,
    order: {},
    user: {},
    card: {},
  }

  async componentDidMount() {
    const { match } = this.props;
    const { userId, orderId } = match.params;

    const getUserFromFirebase = await firebase.database().ref(`/users/${userId}`).once('value');
    await firebase.database().ref(`orders/${userId}/${orderId}`).on('value', (snapshot) => {
      const order = snapshot.toJSON();
      const cardDetails = getUserFromFirebase.val() && order && getUserFromFirebase.val().cards
        ? getUserFromFirebase.val().cards[order.cardId]
        :  {}
    
      this.setState({
        order,
        isLoading: false,
        user: getUserFromFirebase.val(),
        card: cardDetails,
      });
    })
  }

  centsToDollars = cents => {
    return  cents ? `$${(cents/100).toFixed(2)}` : `$${0}`;
  }

  handleQuoteCreation = async (event) => {
    event.preventDefault();

    const { match } = this.props;
    const { userId, orderId } = match.params;
    const quotedTotal = event.target.quotedTotal.value;

    try {
      const response = await fetch(REACT_APP_CLOUD_FUNCTIONS_DOMAIN + '/createQuoteForShoes', {
        method: 'POST',
        body: JSON.stringify({
          userId,
          orderId,
          quotedTotal: String(quotedTotal),
        }),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      alert('Successfully created quote!');
    } catch (error) {
      alert(error?.message || error);
    }
  }

  // sets the order status as complete and sends the order back to the customer
  // if they choose delivery
  handleOrderStatusUpdate = async () => {
    const { match } = this.props;
    const { userId, orderId } = match.params;

    try {
      const response = await fetch(REACT_APP_CLOUD_FUNCTIONS_DOMAIN + '/setOrderStatusAsComplete', {
        method: 'POST',
        body: JSON.stringify({
          userId,
          orderId,
        }),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      alert('Successfully updated order status!');
    } catch (error) {
      alert(error?.message || error);
    }
  }

  render() {
    const { isLoading, order, card, user } = this.state;

    if (isLoading || !order) return <div />;

    const {lowerTotal, upperTotal} = order;
    let total = '';

    if (lowerTotal !== upperTotal) {
      total += `${this.centsToDollars(lowerTotal)} - ${this.centsToDollars(upperTotal)}`;
    } else {
      total += this.centsToDollars(lowerTotal);
    }

    return (
      <div>
        <h3 className="page-header">View Order</h3>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="shoes">
              <h5>Shoes</h5>
              <br/>
              {Object.values(order.shoes).map((shoe, index) => {
                const repairsLength = shoe.repairs?.length;
                const {lowerPrice, upperPrice} = shoe;
                let price = '';

                if (lowerPrice !== upperPrice) {
                  price += `${this.centsToDollars(lowerPrice)} - ${this.centsToDollars(upperPrice)}`;
                } else {
                  price += this.centsToDollars(lowerPrice);
                }

                return (
                  <div key={String(index)} className="section">
                    {shoe.photo ? <img className="shoe-image" alt="" src={shoe.photo} /> : null}
                    <p>Description: {shoe.description}</p>
                    <p>Shine Method: {shoe.shineMethod}</p>
                    <p>Repairs: {shoe.repairs ? Object.values(shoe.repairs).map((label) => repairsLength > 1 ? `${label}, ` : label) : 'None'}</p>
                    <p>Price: {price}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <h5>Details</h5>
            <br />

            <p>Status: {order?.status}</p>
            <p>User name: {user?.name?.firstName} {user?.name?.lastName}</p>
            <p>User email: {user?.email}</p>
            <p>User phone number: {user?.phone}</p>
            <p>Payment Method: {card ? `${card.brand} - ${card.last4}` : 'Unknown'}</p>
            {order.deliveryAddress ? <p>Delivery Address: {order.deliveryAddress}</p> : null}
            {order.deliveryAddress2 ? <p>Delivery Address 2: {order.deliveryAddress2}</p> : null}
            {order.deliveryCompany ? <p>Delivery Company: {order.deliveryCompany}</p> : null}
            {order.deliveryFloor ? <p>Delivery Floor: {order.deliveryFloor}</p> : null}
            {order.deliverySuite ? <p>Delivery Suite: {order.deliverySuite}</p> : null}
            {order.deliveryNotes ? <p>Delivery Notes: {order.deliveryNotes}</p> : null}
            {order.pickupDate ? <p>Pickup Date: {Moment(order.pickupDate).format('MM/DD/YYYY')} from {order.pickupTime}</p> : null}
            {order.deliveryDate ? <p>Delivery Date: {Moment(order.deliveryDate).format('MM/DD/YYYY')} from {order.deliveryTime}</p> : null}
            <p>Delivery Fee: {this.centsToDollars(order.deliveryFee)}</p>
            <p>Tip: {this.centsToDollars(order.tip)}</p>
            <p>Total: {total}</p>

            {order.status !== 'complete' ? (
              <span className="link" onClick={this.handleOrderStatusUpdate}>
                Set Order as Complete (calls delivery driver if there's a pickup)
              </span> 
            ) : null}
            {order.status === 'unpaid' ? (
              <form onSubmit={this.handleQuoteCreation}>
                <div className="form-group">
                  <label>Quoted Price</label>
                  <input
                    type="number"
                    name="quotedTotal"
                    className="form-control"
                    placeholder="5.00"
                  />
                </div>
                <button type="submit" className="btn btn-success">Send Quote</button>
              </form>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Order;
